import { useControllerContext } from "../../hooks/controller-context";
import {
  ControllerHeaderInfoBox,
  ControllerHeaderInfoEdit,
  ControllerHeaderInfoInputWrapper,
  ControllerHeaderInfoWrapper,
} from "./style";
import { useRef, useState } from "react";
import { setTournamentLevelTime } from "../../../../api/tournament-timer";
import { TimerControllerInputBox } from "../../style";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";
import { isTournamentAccess } from "../../../../utils/owner";

const TimerControllerHeaderInfo = () => {
  const { timeInfo, data, level } = useControllerContext();
  const [onTimeInput, setOnTimeInput] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const pub = useRecoilValue(pubState);

  const formatTime = () => {
    if (!timeInfo?.elapsedTimeInCurrentLevel) return "";

    const time = timeInfo?.elapsedTimeInCurrentLevel;
    if (time.includes(":")) {
      const [hh, mm] = time.split(":");
      return `${hh}분 ${mm}초`;
    }
    if (time.includes("분")) {
      const [hh, MM] = time.split("분");
      const mm = MM.split("초")[0];
      return `${hh}:${mm}`;
    }

    return "";
  };

  const onTimeClick = async () => {
    if (!onTimeInput) {
      setOnTimeInput(true);
      return;
    }

    if (!data || !data.timerDto?.id) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }
    if (minutes < 0 || seconds < 0) {
      alert("0보다 작은 값은 저장할 수 없습니다.  ");
      return;
    }

    const currentLevel = data.structure.find((item) => item.level === level);
    if (!currentLevel || !currentLevel.id) {
      alert("재시도해주세요");
      return;
    }

    const time = (minutes * 60 + seconds) * 1000;

    if (currentLevel.time * 1000 * 60 < time) {
      alert("현재 레벨 내에 저장된 시간보다 크게 설정할 수 없습니다. ");
      return;
    }

    try {
      await setTournamentLevelTime(data.timerDto.id, currentLevel?.id, time);
    } catch (e: any) {
      console.error(e);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    } finally {
      setMinutes(0);
      setSeconds(0);
      setOnTimeInput(false);
    }
  };

  const getTotalCount = () => {
    if (!data) return "";

    return data.entryUserCount + data.adOnUserCount + data.reBuyInUserCount;
  };

  return (
    <ControllerHeaderInfoWrapper>
      <ControllerHeaderInfoBox>
        <div className="title">브레이크까지 남은 시간</div>
        <div className="value">{timeInfo?.timeUntilNextBreak}</div>
      </ControllerHeaderInfoBox>
      <ControllerHeaderInfoBox>
        <div className="title">현재 레벨 시간</div>
        <ControllerHeaderInfoEdit className="value" isInput={onTimeInput}>
          {onTimeInput ? (
            <ControllerHeaderInfoInputWrapper>
              <TimerControllerInputBox width="104px" height="70px" font="50px">
                <input
                  value={String(minutes).padStart(2, "0")}
                  onChange={(e) => setMinutes(+e.target.value)}
                  onClick={(e) => e.currentTarget.select()}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      inputRef.current?.focus();
                    }
                  }}
                />
              </TimerControllerInputBox>
              <TimerControllerInputBox width="104px" height="70px" font="50px">
                <input
                  value={String(seconds).padStart(2, "0")}
                  onChange={(e) => setSeconds(+e.target.value)}
                  onClick={(e) => e.currentTarget.select()}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      onTimeClick();
                    }
                  }}
                  ref={inputRef}
                />
              </TimerControllerInputBox>
            </ControllerHeaderInfoInputWrapper>
          ) : (
            <div className="time">{formatTime()}</div>
          )}
          <div className="button" onClick={onTimeClick}>
            변경
          </div>
        </ControllerHeaderInfoEdit>
      </ControllerHeaderInfoBox>
      <ControllerHeaderInfoBox>
        <div className="title">전체 엔트리</div>
        <div className="value">{getTotalCount()}</div>
      </ControllerHeaderInfoBox>
      <ControllerHeaderInfoBox>
        <div className="title">현재 플레이어</div>
        <div className="value">{data?.userCount}</div>
      </ControllerHeaderInfoBox>
    </ControllerHeaderInfoWrapper>
  );
};

export default TimerControllerHeaderInfo;
